export const BASE_URL_ANALYTICS = '/analytics-reporting/analytics_gateway';
